import { HOST } from "../constants/HostConstants";
import { fetchWithRetry } from "../utils/apiRetry";

export const addUser = async (
  username,
  email_address,
  password,
  legal_first_name,
  legal_last_name,
  class_type,
  phone_number,
  professionId,
  companyName,
  position,
  brokerageName,
  brokerageNumber,
  brokerName,
  brokerNumber,
  brokeragePhone,
  brokerageEmail,
  // NEW PARAMETERS:
  isRealtor,
  isBroker,
  builderNumber,
  builderEmail,
  builderSupervisorName,
  builderSupervisorEmail,
  titleCompanyName,
  titleCompanyAddress,
  titleCompanyPhone,
  titleCompanySupervisorName,
  titleCompanySupervisorEmail,
  companyLicenseNumber,
  supervisorName,
  supervisorLicenseNumber,
  branchAddress,
  branchPhone,
  { setLoading, setErr, setRegistered, setWaitingMessage = null },
  key_balance,
) => {
  const markRegistered =
    typeof setRegistered === "function" ? setRegistered : () => {};
  try {
    setErr(null);
    if (setWaitingMessage) setWaitingMessage("Creating your account...");

    const date = new Date();
    const currentDay = String(date.getDate()).padStart(2, "0");
    const currentMonth = String(date.getMonth() + 1).padStart(2, "0");
    const currentYear = date.getFullYear();
    const currentDate = `${currentYear}-${currentMonth}-${currentDay}`;

    const res = await fetchWithRetry(
      `${HOST}/api/user/userAdd`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          emailAddress: email_address,
          password,
          legalFirstName: legal_first_name,
          legalLastName: legal_last_name,
          classType: class_type,
          phoneNumber: phone_number,
          keyBalance: key_balance,
          companyName,
          position,
          professionId,
          brokerageName,
          brokerageNumber,
          brokerName,
          brokerNumber,
          brokeragePhone,
          brokerageEmail,
          // NEW FIELDS:
          isRealtor,
          isBroker,
          builderNumber,
          builderEmail,
          builderSupervisorName,
          builderSupervisorEmail,
          titleCompanyName,
          titleCompanyAddress,
          titleCompanyPhone,
          titleCompanySupervisorName,
          titleCompanySupervisorEmail,
          companyLicenseNumber,
          supervisorName,
          supervisorLicenseNumber,
          branchAddress,
          branchPhone,
          date: currentDate,
        }),
      },
      {
        maxRetries: 3,
        initialDelay: 3000,
        onWaiting: (isWaiting, message) => {
          if (setWaitingMessage) {
            setWaitingMessage(isWaiting ? message : "Creating your account...");
          }
        },
      },
    );

    if (setWaitingMessage) setWaitingMessage(null);

    // Try to parse JSON, but don’t crash if server returns plain text
    const text = await res.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      data = text; // plain string error message
    }

    if (!res.ok) {
      const msg =
        (data && data.error) ||
        (typeof data === "string" ? data : null) ||
        "Registration failed. Please try again.";
      setErr(msg);
      setLoading(false);
      return;
    }

    // If server still returns {error: "..."} with 200 (older behavior)
    if (data?.error) {
      setErr(data.error);
      setLoading(false);
      return;
    }

    markRegistered(true);
    setLoading(false);
  } catch (err) {
    if (setWaitingMessage) setWaitingMessage(null);
    setErr(
      err?.message ||
        "Registration failed. Server may be starting up - please try again in a moment.",
    );
    setLoading(false);
  }
};
